import { render, staticRenderFns } from "./PageEditRole.vue?vue&type=template&id=020520a9"
import script from "./PageEditRole.vue?vue&type=script&lang=js"
export * from "./PageEditRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports